import React from 'react';
import type { ComponentProps } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { height, minHeight, minWidth, width } from 'styled-system';

import { fill } from '../../theme/system-utilities';
import IconBase from '../Icon';

const iconResponsiveSizes = ['24px', null, null, '28px'];

const UnstyledArrowIcon = styled(IconBase)<any>`
  ${({ isCollapsed }) => css`
    transform: rotate(${isCollapsed ? 90 : -90}deg);
  `}
  ${height};
  ${minHeight};
  ${width};
  ${minWidth};
  ${fill};
`;

const ArrowIcon = (props: ComponentProps<typeof UnstyledArrowIcon>) => (
  <UnstyledArrowIcon
    height={iconResponsiveSizes}
    minHeight={iconResponsiveSizes}
    width={iconResponsiveSizes}
    minWidth={iconResponsiveSizes}
    fill="sys.neutral.border.hover"
    role="presentation"
    name="arrowRight"
    {...props}
  />
);

export default ArrowIcon;
